
import Vue from 'vue';
import EuButton from '../Button/Button.vue';
import EuCard from '../Card/Card.vue';
import ArrowDown from '../../../Icons/ArrowDownLight.vue';
/**
- This component is to show the purchased detail and items
- Detail items showed when card Is expanded
 */
export default Vue.extend<any, any, any, any>({
  name: 'PurchaseDetail',
  components: {
    EuButton,
    EuCard,
    ArrowDown
  },
  data() {
    return {
      expand: false
    };
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set card elevation type (sort by thickness: thin, interactive, float, thicker)
     */
    elevation: {
      type: String,
      default: ''
    },
    /**
     * Set title
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Set subtitle text
     */
    subtitle: {
      type: String,
      default: ''
    },
    /**
     * Set value text
     */
    value: {
      type: String,
      default: ''
    },
    /**
     * Set button to disabled
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /*
     * Set button label
     */
    buttonLabel: {
      type: String,
      default: 'Pay Now'
    },
    /**
     * Set arrow icon
     */
    arrowIcon: {
      type: [String, Object],
      default: () => ArrowDown
    },
    /**
     * Set arrow color
     */
    arrowFill: {
      type: String,
      default: '#ff6400'
    },
    /**
     * Set purchase detail in single line
     */
    singleLine: {
      type: Boolean,
      default: false
    },
    /**
     * Hide arrow icon
     */
    noArrow: {
      type: Boolean,
      default: false
    },
    /**
     * Set expander on active state
     */
    expanded: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.expand = this.expanded;
  },
  computed: {
    computedHeaderClass() {
      return {
        bordered: this.expand,
        expand: this.expand
      };
    }
  },
  methods: {
    handleClick(e: any) {
      /**
       * Click card button purchase
       * @event click
       * @type {function}
       */
      this.$emit('click', e);
    },
    handleCardClick(e: any) {
      /**
       * Click card method
       * @event click-card
       * @type {function}
       */
      this.$emit('click-card', e);
    },
    handleExpand(e: any) {
      this.expand = !this.expand;
      /**
       * Click expand purchase detail
       * @event expand
       * @type {function}
       */
      this.$emit('expand', e);
    }
  }
});
